var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecruitCandidate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M-4208.286-4703h-27.428a2.216,2.216,0,0,1-2.285-2.285,9.548,9.548,0,0,1,2.951-6.19c2.827-2.828,7.339-4.323,13.048-4.323s10.221,1.5,13.048,4.323a9.551,9.551,0,0,1,2.953,6.19,2.044,2.044,0,0,1-1.094,1.979A2.987,2.987,0,0,1-4208.286-4703ZM-4222-4713.972a21.757,21.757,0,0,0-7.561,1.185,11.574,11.574,0,0,0-4.194,2.6,7.809,7.809,0,0,0-2.417,4.883l0,.461h28.349l0-.459a7.766,7.766,0,0,0-2.416-4.885,11.579,11.579,0,0,0-4.2-2.6A21.764,21.764,0,0,0-4222-4713.972Zm0-5.485a7.78,7.78,0,0,1-7.771-7.771A7.781,7.781,0,0,1-4222-4735a7.781,7.781,0,0,1,7.771,7.772A7.78,7.78,0,0,1-4222-4719.457Zm0-13.715a5.95,5.95,0,0,0-5.943,5.943,5.95,5.95,0,0,0,5.943,5.942,5.95,5.95,0,0,0,5.943-5.942A5.95,5.95,0,0,0-4222-4733.172Z",
    transform: "translate(4238 4735.001)",
    fill: "#600097"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitCandidate);
export default __webpack_public_path__ + "static/media/recruitCandidate.f4990e836c2a2ac90326ba9be6ced75f.svg";
export { ForwardRef as ReactComponent };